interface GetTourCardLocalStorageKeyInput {
    cardId: string;
    entityId: string;
    key: string;
    userId: string;
}

export const getTourCardLocalStorageKey = ({
    cardId,
    entityId,
    key,
    userId,
}: GetTourCardLocalStorageKeyInput): string =>
    `insights-tour.userId:${userId}.entityId:${entityId}.cardId:${cardId}.${key}`;
